// libraries
import React from 'react'
import dayjs from 'dayjs'

// components
import Section from '/react4xp/components/Section'
import ImageWithCaption from '/react4xp/components/ImageWithCaption'
import Button from '/react4xp/components/Button'
import RichText from '/react4xp/components/RichText'

// svg
import { UxArrowRight } from '/react4xp/components/Svg/Ux/Arrow'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

// prop types
export interface ArticleWrapperProps {
    date?: string
    title?: string
    intro?: string
    primaryButton?: {
        text?: string
        href?: string
        external?: boolean
    }
    secondaryButton?: {
        text?: string
        href?: string
        external?: boolean
    }
    featuredImage?: {
        src?: string
        srcMobile?: string
        alt?: string
        caption?: string
    }
    content?: string
}

export default function Article({
    date,
    title,
    intro,
    primaryButton,
    secondaryButton,
    featuredImage,
    content
}: ArticleWrapperProps) {
	return (
        <main id='main' className='page-article'>

            <Section
                marginTop='small'
                marginBottom='small'
                className='page-article__header'
            >
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-10 offset-lg-1 col-xl-6 offset-xl-3'>

                            {isNonWhitespaceString(date) && (
                                <p className='page-article__header__date text-smallest'>
                                    {dayjs(date).locale('nb').format('D. MMM YYYY').toLocaleLowerCase()}
                                </p>
                            )}

                            {isNonWhitespaceString(title) && (
                                <h1 className='page-article__header__title h1-hero'>
                                    {title}
                                </h1>
                            )}

                            {isNonWhitespaceString(intro) && (
                                <div
                                    className='page-article__header__intro text-big'
                                    dangerouslySetInnerHTML={{ __html: intro }}
                                    suppressHydrationWarning
                                />
                            )}

                            {(isNonWhitespaceString(primaryButton?.text) || isNonWhitespaceString(primaryButton?.href) || isNonWhitespaceString(secondaryButton?.text) || isNonWhitespaceString(secondaryButton?.href)) && (
                                <div className='page-article__header__buttons'>

                                    {isNonWhitespaceString(primaryButton?.text) && (
                                        <Button
                                            noUnderline
                                            href={primaryButton?.href}
                                            target={primaryButton?.external}
                                        >
                                            {primaryButton?.text}
                                        </Button>
                                    )}

                                    {isNonWhitespaceString(secondaryButton?.text) && (
                                        <Button
                                            noUnderline
                                            noBorders
                                            className='secondary-button'
                                            href={secondaryButton?.href}
                                            target={secondaryButton?.external}
                                        >
                                            {secondaryButton?.text} <UxArrowRight />
                                        </Button>
                                    )}

                                </div>
                            )}

                            {featuredImage?.src && (
                                <ImageWithCaption
                                    src={featuredImage?.src} // 1150px x 700px
                                    srcMedium={featuredImage?.srcMobile} // 650px x 400px
                                    alt={featuredImage?.alt}
                                    caption={featuredImage?.caption}
                                    className='page-article__header__image'
                                />
                            )}

                        </div>
                    </div>
                </div>
            </Section>

            <Section
                className='page-article__body'
                marginTop='none'
                marginBottom='big'
            >
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-10 offset-lg-1 col-xl-6 offset-xl-3 page-article__body__content'>
                            <RichText
                                content={content}
                                className='page-article__body__content__rich-text'
                            />
                        </div>
                    </div>
                </div>
            </Section>

        </main>
	)
}
